const key = Symbol.for("@openDAW/lib-std");
if (globalThis[key]) {
    console.debug(`%c${key.description}%c is already available in ${globalThis.constructor.name}.`, "color: hsl(10, 83%, 60%)", "color: inherit");
}
else {
    globalThis[key] = true;
    console.debug(`%c${key.description}%c is now available in ${globalThis.constructor.name}.`, "color: hsl(200, 83%, 60%)", "color: inherit");
}
export * from "./arrays";
export * from "./attempts";
export * from "./bijective";
export * from "./binary-search";
export * from "./bits";
export * from "./cache";
export * from "./color";
export * from "./comparators";
export * from "./curve";
export * from "./data";
export * from "./decorators";
export * from "./editing";
export * from "./generators";
export * from "./geom";
export * from "./hash";
export * from "./intervals";
export * from "./iterables";
export * from "./lang";
export * from "./listeners";
export * from "./math";
export * from "./maps";
export * from "./multimap";
export * from "./notifier";
export * from "./numeric";
export * from "./objects";
export * from "./observables";
export * from "./observers";
export * from "./option";
export * from "./parameters";
export * from "./predicates";
export * from "./progress";
export * from "./random";
export * from "./range";
export * from "./schema";
export * from "./selection";
export * from "./sets";
export * from "./sorted-set";
export * from "./string-mapping";
export * from "./strings";
export * from "./runtime-notifier";
export * from "./runtime-signal";
export * from "./terminable";
export * from "./time-span";
export * from "./sync-stream";
export * from "./uuid";
export * from "./value-guides";
export * from "./value-mapping";
export * from "./errors";
